import { Camera, Video, Map, Mail, Building2, Users, Newspaper, CheckCircle } from "lucide-react";

// Real marketing images from Chris Pierog listings
const MARKETING_IMAGES = [
  {
    url: "https://customer-assets.emergentagent.com/job_a0897f07-e635-4cd5-9eb9-21140ceaa71c/artifacts/pasumgb1_drone%20shot%20with%20map.jpg",
    alt: "Aerial drone photography with property boundaries in Grays Harbor",
    label: "Drone Photography"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_a0897f07-e635-4cd5-9eb9-21140ceaa71c/artifacts/8a6erccq_interior%20shot%20kitchenwithvirtualstaging.jpg",
    alt: "Professional interior photography with virtual staging - kitchen",
    label: "Interior Photography"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_a0897f07-e635-4cd5-9eb9-21140ceaa71c/artifacts/olpgr5w0_exterior%20shot-%20frontofhouse.jpg",
    alt: "Professional exterior home photography in Grays Harbor WA",
    label: "Exterior Shots"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_a0897f07-e635-4cd5-9eb9-21140ceaa71c/artifacts/yd2kxl5m_interior%20living%20shot.jpg",
    alt: "Professional living room photography with staging",
    label: "Living Spaces"
  },
];

const MARKETING_FEATURES = [
  { icon: Camera, text: "In-house professional photographer" },
  { icon: Video, text: "Drone photography and videography" },
  { icon: Map, text: "2D floor plans on every listing" },
  { icon: Mail, text: "Postcards and direct mail campaigns" },
  { icon: Newspaper, text: "Custom real estate magazine in 50+ local businesses" },
  { icon: Building2, text: "Multiple offices: Hoquiam, Aberdeen, Montesano, Ocean Shores, Westport" },
  { icon: Users, text: "Facebook page with 7,000+ followers" },
  { icon: Mail, text: "Weekly newsletter with 20,000+ subscribers" },
];

export const UnmatchedMarketing = () => {
  return (
    <section 
      className="py-16 md:py-20 bg-white"
      data-testid="marketing-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-10">
          <p className="text-xs uppercase tracking-widest font-semibold text-[#4d6153] mb-3">
            Why List With Us
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif tracking-tight text-[#132723] mb-4">
            Unmatched Marketing. Proven Results.
          </h2>
          <p className="text-[#4d6153]">
            We take marketing seriously. That's why we sell more real estate in Grays Harbor every single year.
          </p>
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-10">
          {MARKETING_IMAGES.map((image, index) => (
            <div key={index} className="relative group overflow-hidden">
              <img 
                src={image.url} 
                alt={image.alt}
                className="w-full h-40 md:h-52 object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              <p className="absolute bottom-2 left-2 md:bottom-3 md:left-3 text-white text-xs md:text-sm font-medium">
                {image.label}
              </p>
            </div>
          ))}
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3 mb-10">
          {MARKETING_FEATURES.map((feature, index) => (
            <div 
              key={index}
              className="flex items-center gap-3 p-4 bg-[#f0efeb]"
            >
              <feature.icon className="w-5 h-5 text-[#00453d] flex-shrink-0" />
              <span className="text-sm text-[#132723]">{feature.text}</span>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="bg-[#132723] p-6 md:p-10 text-center">
          <p className="text-lg md:text-xl font-serif text-white mb-3">
            "When your home hits the market, it is marketed EVERYWHERE!"
          </p>
          <p className="text-white/70 text-sm md:text-base">
            We live and breathe real estate in Aberdeen, Hoquiam, Montesano, Ocean Shores, and all of Grays Harbor & Pacific Counties.
          </p>
        </div>
      </div>
    </section>
  );
};

export default UnmatchedMarketing;
